module.exports = __webpack_public_path__ + "media/luxury-2026/nash-architectural-exterior-960-aa432231.jpg";